// extracted by mini-css-extract-plugin
export default {"Subscriptions":"Subscriptions_Subscriptions__22vDO","Legal":"Subscriptions_Legal__JuYMC","TermsOfUse":"Subscriptions_TermsOfUse__IFo1s"};